import { useState } from "react";
import { useTranslation } from "react-i18next";
import BasicDialog from "../../base/BasicDialog";
import { Grid, Tab, Tabs } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { ClausesHistoryTab } from "./ClausesHistoryTab";
import { ActualClausesTab } from "./ActualClausesTab";
import { USER_ROLES } from "../../../helpers/constants";
import { useHasRole } from "../../../hooks/auth/useCheckPermission";
import { AnonymizeCustomerDialogButton } from "./CustomerAnonymizationButton";

export const PersonClausesDialog = (props) => {

    const hasPermissionToAnonymizeCustomer = useHasRole([
        USER_ROLES.ADMIN, 
        USER_ROLES.SALES, 
        USER_ROLES.SALES_LEGAL, 
        USER_ROLES.SALES_MANAGER, 
    ]) 

    const [tab, setTab] = useState(props.initialTab || "actual");
    const { open, onClose, personId, customerId } = props;
    
    const { t } = useTranslation();

    return (
        <BasicDialog
            open={open}
            onClose={onClose}
            title={t("clients.PersonClausesDialog.buttonLabel")}
            maxWidth="lg"
            minWidth={1000}
            showDialogActions={false}
            titleSx={{textAlign: "center"}}
        >
            {!props.readOnly && hasPermissionToAnonymizeCustomer && <Grid container justifyContent={"flex-end"}><AnonymizeCustomerDialogButton customerId={customerId}/> </Grid>}
            <TabContext value={tab}>
                <Tabs
                    variant="fullWidth"
                    value={tab}
                    onChange={(e, newValue) => setTab(newValue)}
                >
                    <Tab value={"actual"} label={t("clients.PersonClausesDialog.actualClauses")} />
                    <Tab value={"history"} label={t("clients.PersonClausesDialog.clausesHistory")}/>
                </Tabs>
                <TabPanel value={"actual"} sx={{ p: 0 }}>
                    <Grid
                        item
                        xs
                        sx={{
                            // bgcolor: "whitesmoke",
                            // borderRadius: 2,
                            p: 2,
                        }}
                    >
                        <ActualClausesTab personId={props.personId} personName={props.personName} readOnly={props.readOnly}/>
                        {/* <DiscountProposalForm productIds={props.productIds} onClose={props.onClose}/> */}
                    </Grid>
                </TabPanel>
                <TabPanel value={"history"} sx={{ p: 0 }}>
                    <Grid
                        item
                        xs
                        sx={{
                            // bgcolor: "whitesmoke",
                            // borderRadius: 2,
                            p: 2,
                        }}
                    >
                        <ClausesHistoryTab personId={props.personId} personName={props.personName}/>
                    </Grid>
                </TabPanel>
            </TabContext>
        </BasicDialog>
    );
};
